module.exports = { "default": require("core-js/library/fn/object/is-frozen"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/is-frozen.js
// module id = 773
// module chunks = 1